<template>
  <div class="helpIndex m_b_40 b_b" style="white-space: normal">
    <allMallSerch style="border-bottom: 1px solid #e6e6e6"></allMallSerch>
    <div
      class="split_2_8"
      style="height: calc(100% - 140px); width: 1300px;margin: auto"
    >
      <div
        class="o_a b_f1 b_b"
        style="margin-top: 30px; height: calc(100% - 30px)"
      >
        <div class="font20 p_10 commonHelpItem t_c b_b">帮助中心</div>
        <div
          v-for="(item, index) in list"
          :key="index"
          @click="chooseHelp(item, index)"
          class="font16 p_10 t_c b_f1 helpItem b_b"
        >
          <span>{{ item.type }}</span>
        </div>
      </div><div class="h100 o_a">
        <router-view :choosenSubItem="choosenSubItem" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'help',
  data () {
    return {
      list: [],
      activeIndex: 0,
      choosenSubItem: null,
      keyWord: '',
      recentLocalKey: JSON.parse(
        window.localStorage.getItem('recentLocalKey') || '[]'
      )
    }
  },
  mounted () {
    document.title = '百钢一下 | 钢铁电商，百炼成钢'
    this.getList()
  },
  methods: {
    getList () {
      this.$axiox.post('/baigang/shop/question/query', {}).then((p) => {
        this.list = p.data
        if (this.list.length) {
          this.chooseHelp(this.list[0])
        }
      })
    },
    chooseHelp (item, i) {
      if (this.$route.path !== '/helpSub') {
        this.$router.push({
          path: '/helpSub'
        })
      }
      // this.$nextTick(() => {
      this.activeIndex = i
      this.choosenSubItem = item
      // });
    },
    getAllList () {
      if (this.keyWord) {
        let flag = true
        for (let i = 0; i < this.recentLocalKey.length; i++) {
          if (
            this.keyWord === this.recentLocalKey[i].keyword ||
            !this.keyWord.trim()
          ) {
            flag = false
          }
        }
        if (!this.keyWord.trim()) {
          flag = false
        }
        if (flag) {
          this.recentLocalKey.splice(0, 0, { keyword: this.keyWord })
          if (this.recentLocalKey.length > 30) {
            this.recentLocalKey.splice(this.recentLocalKey.length - 1, 1)
          }
          window.localStorage.setItem(
            'recentLocalKey',
            JSON.stringify(this.recentLocalKey)
          )
        }
        this.$router.push({
          name: 'searchResult',
          query: {
            name: this.keyWord
          }
        })
      }
    }
  }
}
</script>

<style>
.searchBlock {
  width: 600px;
  height: 40px;
  border: 1px solid #D71E1E;
  border-radius: 4px;
}
.searchBlock input {
  flex: 1;
  height: 100%;
  border: none;
  border-radius: 4px 0px 0px 4px;
  padding: 0 10px;
}
.searchBlock div {
  padding-left: 10px;
  padding-right: 9px;
  height: 100%;
  background: #D71E1E;
  color: #fff;
  font-weight: bold;
  text-align: center;
  line-height: 40px;
}
.helpIndex {
  margin-top: 32px;
  height: calc(100% - 72px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page/help/help.vue